import { useId } from 'react';
import { Label } from '../../shared/ui/label';
import { Switch } from '../../shared/ui/switch';
import type { HuddleCameraDetails, HuddleCameraPreferences } from './HuddleCamera';

export function HuddleCameraTracking({ details, disabled, onChange }: {
  details: HuddleCameraDetails; disabled: boolean; onChange: (preferences: HuddleCameraPreferences) => void;
}) {
  const id = useId();
  const supported = details.capabilities.effects?.faceFraming;
  const active = details.settings.effects?.faceFraming;
  const adjustable = !!supported?.includes(true) && supported.includes(false);
  const reported = typeof active === 'boolean';
  const mac = /Mac/.test(navigator.platform) && !(navigator.maxTouchPoints > 1);
  const focus = details.settings.modes.focusMode;
  return <div className="mt-3 space-y-2 border-t border-border pt-3">
    <div className="flex items-center justify-between gap-3">
      <div><Label htmlFor={adjustable ? id : undefined} className="text-xs">Follow me</Label>
        <p role="status" className="text-[11px] text-muted-foreground">{reported ? active ? 'On · keeps you in frame as you move.' : 'Off' : 'Your device does not report its tracking status.'}</p>
      </div>
      {adjustable && <Switch id={id} aria-label="Follow me" checked={active === true} disabled={disabled || details.applying}
        onCheckedChange={enabled => onChange({ ...details.preferences, effects: { ...details.preferences.effects, faceFraming: enabled } })} />}
      {!adjustable && reported && <span className="text-[11px] text-muted-foreground">Device setting</span>}
    </div>
    {!adjustable && <p className="text-[11px] text-muted-foreground">{mac
      ? <>On a supported Mac, turn your camera on, open the Video menu in the macOS menu bar, then enable Centre Stage. <a className="underline underline-offset-2" href="https://support.apple.com/en-gb/111102" target="_blank" rel="noopener noreferrer">Centre Stage help</a></>
      : 'If your camera offers automatic framing in its device controls, enable it there. Your Huddle uses the camera’s video feed.'}</p>}
    {focus && <p className="text-[11px] text-muted-foreground">{focus === 'continuous' ? 'Continuous autofocus is on.'
      : focus === 'manual' ? 'Focus is set to manual.' : focus === 'single-shot' ? 'Focus adjusts once when requested.' : 'Autofocus is off.'}</p>}
  </div>;
}
